import {
  ChangeDetectionStrategy,
  Component,
  inject,
  output,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIconButton } from '@angular/material/button';
import {
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { MatListItem, MatNavList } from '@angular/material/list';
import { RouterLink } from '@angular/router';
import { NavigationService } from '@jfw/angular/ecommerce/core';
import { environment } from 'ecommerce/dealer-portal/src/environments/environment';
import { DealerUserService } from '../../../services/dealer-user/dealer-user.service';
import { ModuleAccessService } from '../../../services/module-access/module-access.service';

@Component({
  selector: 'app-header-sidenav',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    MatIconButton,
    MatIcon,
    MatNavList,
    MatListItem,
    RouterLink,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderSidenavComponent {
  private dealerUserService = inject(DealerUserService);
  private moduleAccessService = inject(ModuleAccessService);
  private navigationService = inject(NavigationService);

  public signOut = output<boolean>();

  public newSite = toSignal(this.moduleAccessService.newSite$);
  public moduleGroups = toSignal(this.moduleAccessService.moduleAccessGroups$);

  public currentDealer = toSignal(this.dealerUserService.currentDealer$);
  public enableDealerReports = environment.enableDealerReports;

  public closeSidenav(): void {
    this.navigationService.showHeaderNav(false);
  }

  public onSignOut(): void {
    this.signOut.emit(true);
  }
}
